// src/modules/app-views/_apps/appmulti/orders/pages/Document/cardHeaderItems.js
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import {
  EnvironmentOutlined,
  GlobalOutlined,
  LinkOutlined,
  MailOutlined,
  PhoneOutlined,
  UserOutlined,
} from '@ant-design/icons';
import translateX from 'utils/translateX';
import { parsePhoneToDisplay } from 'utils/helpers';

// *******************************************************************************
// ITEMS
// *******************************************************************************
export const orderBuyerEmailItem = record => ({
  key: 'buyerEmail',
  icon: <MailOutlined />,
  label: record?.__buyer?.email || null,
  tooltipText: translateX('email'),
  tooltipPlacement: 'right',
  onClick: null,
});

export const orderBuyerPhoneItem = record => ({
  key: 'buyerPhone',
  icon: <PhoneOutlined />,
  label: record?.__buyer?.phone
    ? parsePhoneToDisplay(record.__buyer.phone)
    : null,
  tooltipText: translateX('phone'),
  tooltipPlacement: 'right',
  onClick: null,
});

export const orderDestinyItem = record => ({
  key: 'destiny',
  icon: <EnvironmentOutlined />,
  label: record?.destiny ? translateX(record.destiny) : null,
  tooltipText: translateX('destiny'),
  tooltipPlacement: 'right',
  onClick: null,
});

export const orderSellerItem = record => {
  const seller = record?.__seller?.name;
  return {
    key: 'seller',
    icon: seller ? <UserOutlined /> : <GlobalOutlined />,
    label: seller || translateX('online_sale'),
    tooltipText: translateX('seller'),
    tooltipPlacement: 'right',
    onClick: null,
  };
};

export const orderPaymentLinkItem = record => {
  const url = record?.__receivables?.[0]?.paymentUrl || record?.paymentUrl;
  return {
    key: 'paymentLink',
    icon: <LinkOutlined />,
    label: url ? translateX('view_billing') : null,
    tooltipText: translateX('payment_link'),
    tooltipPlacement: 'right',
    onClick: url ? () => window.open(url, '_blank') : null,
  };
};

